import { render, staticRenderFns } from "./contract-body.component.vue?vue&type=template&id=c6d5797c"
import script from "./contract-body.component.vue?vue&type=script&lang=ts"
export * from "./contract-body.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports